import React, { setGlobal } from "reactn";
import { mount } from "kanopi-components/Main/mount";
import { fromLocalStorage, parseQueryString } from "kanopi-components/utils/browser";
import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";

import "./settings";
import { setBearer } from "./api";
import Main from "./Main";
import { config } from "./settings";

// Uncomment these lines to hook reactn into the Redux dev tools
// import addReactNDevTools from 'reactn-devtools';
// addReactNDevTools();

datadogRum.init({
  applicationId: config.DATADOG_RUM_APP_ID,
  clientToken: config.DATADOG_RUM_CLIENT_TOKEN,
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "datadoghq.com",
  service: "kanopi-web",
  env: config.STAGE_TYPE,
  version: config.GIT_REVISION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 50,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask",
});

datadogLogs.init({
  clientToken: config.DATADOG_LOG_CLIENT_TOKEN,
  site: "datadoghq.com",
  service: "kanopi-web",
  env: config.STAGE_TYPE,
  version: config.GIT_REVISION,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  forwardConsoleLogs: ["error", "warn"],
});

setGlobal(
  {
    auth: fromLocalStorage("auth", null),
    quoting: {
      enquiry: undefined,
      enabledProducts: parseQueryString({ search: location.search })?.product,
    },
    product: undefined,
  },
  (s) => {
    console.debug("Initial state: ", s);
    setBearer((s.auth || {}).token);
    console.debug("Mounting app");
    mount(<Main />);
  }
);
